<template>

      <span>{{  chipColor(params.value, params.data.date_grouped) }}</span>

</template>

<script>
export default {
  name: 'CellRendererDate',
  computed: {
    chipColor () {
      return (value, date_grouped_type) => {
        return value.substring(0, date_grouped_type)
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
